// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DTpg","title":"styles_title__3OeoT"};